import React, { Component } from "react";
import { Col, FormGroup } from "reactstrap";
import "./MoreSection.css";
import favoritedIcon from "../../../../../assets/heartFilled.png";
import { canAddToGroup } from "../../../../../utils/constants";
import ShareEntity from "../../../../../components/ShareEntity/ShareEntity";
import { connect } from "react-redux";

class MoreSection extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let {
      toolDetails,
      preview,
      canEdit,
      canArchiveAndRestore,
      fromPublicTool,
    } = this.props;
    // console.log(this.props)
    let {
      contactName,
      contactEmailID,
      address,
      contactPhone,
      website,
      isRecommendedByAdmin,
      isArchive,
      isFavorite,
    } = toolDetails;
    let linkClass = "";
    let attachmentClass = "";
    let editClass = "";
    let toolAttachment = undefined;
    let linkStyle = { color: "#5099DE", textDecoration: "none" };
    if (preview) {
      linkClass = "opacity04 disable cursor-default";
    }
    if (toolDetails && toolDetails._id) {
      editClass = "cursor-pointer";
    } else {
      editClass = "opacity04 disable cursor-default";
    }
    if (toolDetails && toolDetails.attachment) {
      if (typeof toolDetails.attachment === "string") {
        toolAttachment = toolDetails.attachment;
      } else {
        toolAttachment = toolDetails.attachmentUrl;
      }
    }

    return (
      <div className="more-section-container">
        <FormGroup>
          <Col className="more-heading">More</Col>
        </FormGroup>
        <FormGroup
          className={
            this.props.hideContact
              ? "displayNone"
              : "mt20 mb02 " + linkClass + " " + editClass
          }
          onClick={this.props.onContactClick}
        >
          <Col sm={2} xs={2} className="text-right">
            <span style={{ color: "#5099DE" }} className="flaticon-mail"></span>
          </Col>
          <Col
            sm={10}
            xs={10}
            className="more-active-link text-left align-self-center"
          >
            Contact
          </Col>
        </FormGroup>
        <FormGroup
          className={"mb02 " + linkClass + " " + editClass}
          onClick={this.props.onExportClick}
        >
          <Col sm={2} xs={2} className="text-right">
            <span
              style={{ color: "#5099DE" }}
              className="flaticon-export"
            ></span>
          </Col>
          <Col
            sm={10}
            xs={10}
            className="more-active-link text-left align-self-center"
          >
            Export
          </Col>
        </FormGroup>
        {!fromPublicTool && (
          <ShareEntity
            comp={
              <FormGroup className={"mb02 " + linkClass + " " + editClass}>
                <Col sm={2} xs={2} className="text-right">
                  <span
                    style={{ color: "#5099DE" }}
                    className="flaticon-share"
                  ></span>
                </Col>
                <Col
                  sm={9}
                  xs={9}
                  className="more-active-link text-left align-self-center ml-1"
                >
                  {"  "}Share
                </Col>
              </FormGroup>
            }
            user={this.props.user}
            entityType="RESOURCES"
            display="POPPER"
            item={toolDetails}
          />
        )}
        {!fromPublicTool && (
          <FormGroup
            className={"mb02 " + linkClass + " " + editClass}
            onClick={this.props.onAddOrRemoveFavorite}
          >
            <Col sm={2} xs={2} className="text-right">
              {isFavorite ? (
                <img style={{ height: "20px" }} src={favoritedIcon} />
              ) : (
                <span
                  style={{ color: "#5099DE" }}
                  className="flaticon-heart"
                ></span>
              )}

              {/* <span style={{color: isFavorite? 'red':'#5099DE'}} className="flaticon-heart"></span> */}
            </Col>
            <Col
              sm={10}
              xs={10}
              className="more-active-link text-left align-self-center"
            >
              {isFavorite ? "Remove from favorites" : "Add to favorites"}
            </Col>
          </FormGroup>
        )}
        {canAddToGroup(toolDetails, this.props.user) ? (
          <FormGroup
            className={"mb02 " + linkClass + " " + editClass}
            onClick={this.props.onAddGroup}
          >
            <Col sm={2} xs={2} className="text-right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#5099DE"
                viewBox="0 0 16 16"
              >
                <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"></path>
              </svg>
            </Col>
            <Col
              sm={10}
              xs={10}
              className="more-active-link text-left align-self-center"
            >
              Add to Group
            </Col>
          </FormGroup>
        ) : null}
        {/* <FormGroup className={''.concat(toolAttachment ? 'cursor-pointer': linkClass).concat((fromPublicTool || canArchiveAndRestore || canEdit)? ' mb02' : ' ')} style={{opacity: toolAttachment ? '1' : '0.4'}} >
                 <Col sm={2} className="text-right">
                  <a href={toolDetails.attachment} target="_blank" style={linkStyle}>
                   <span className="flaticon-clip"></span>
                  </a> 
                 </Col>
                 <Col sm={10} className="more-active-link text-left align-self-center">
                  <a href={toolAttachment} target="_blank" style={linkStyle}>{toolAttachment ? 'View attachment': 'No attachment'}</a>
                 </Col> 
            </FormGroup> */}
        {!fromPublicTool && !isRecommendedByAdmin && canEdit ? (
          <FormGroup
            className={
              linkClass +
              " " +
              editClass.concat(canArchiveAndRestore ? " mb02 " : "")
            }
          >
            <Col sm={2} xs={2} className="text-right">
              <span
                style={{ color: "#5099DE" }}
                className="flaticon-edit"
              ></span>
            </Col>
            <Col
              sm={10}
              xs={10}
              className="more-active-link text-left align-self-center"
              onClick={this.props.editTool}
            >
              Edit
            </Col>
          </FormGroup>
        ) : null}

        {!fromPublicTool &&
          !isRecommendedByAdmin &&
          isArchive &&
          isArchive.value === false &&
          (canArchiveAndRestore || preview) && (
            <FormGroup
              className={linkClass + " " + editClass}
              onClick={this.props.onArchiveClick}
            >
              <Col sm={2} xs={2} className="text-right">
                <span
                  style={{ color: "#5099DE" }}
                  className="flaticon-trash"
                ></span>
              </Col>
              <Col
                sm={10}
                xs={10}
                className="more-active-link text-left align-self-center"
              >
                Archive
              </Col>
            </FormGroup>
          )}

        {!fromPublicTool &&
          !isRecommendedByAdmin &&
          isArchive &&
          isArchive.value &&
          (canArchiveAndRestore || preview) && (
            <FormGroup
              className={linkClass + " " + editClass}
              onClick={this.props.onRestoreTool}
            >
              <Col sm={2} xs={2} className="text-right">
                <span
                  style={{ color: "#5099DE" }}
                  className="flaticon-update"
                ></span>
              </Col>
              <Col
                sm={10}
                xs={10}
                className="more-active-link text-left align-self-center"
              >
                Restore
              </Col>
            </FormGroup>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    
  };
};

export default
  connect(mapStateToProps, mapDispatchToProps)(MoreSection)

